import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OutboxIcon(props: IconProps) {
    return <Icon {...props} iconKey={"outbox"}/>
}
